import { PaginationMeta } from '../models/pagination-meta.model';

/** Laravel-style list response: either a raw array or an envelope with data and optional meta. */
export interface LaravelListEnvelope<T> {
  data?: T[];
  meta?: PaginationMeta;
}

/** Standard API envelope used by backend for non-list endpoints. */
export interface ApiEnvelope<T> {
  data: T;
  message: string;
  status: boolean;
}

export interface NormalizedListResponse<T> {
  data: T[];
  meta: PaginationMeta | null;
}

/**
 * Normalizes a list API response (array or envelope) to a consistent { data, meta } shape.
 * Use in admin and other list endpoints that may return either format.
 */
export function normalizeListResponse<T>(
  response: T[] | LaravelListEnvelope<T>
): NormalizedListResponse<T> {
  if (Array.isArray(response)) {
    return { data: response, meta: null };
  }
  return {
    data: response.data ?? [],
    meta: response.meta ?? null,
  };
}
